import NotFoundComponent from "PFComponents/not_found/not_found";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import EditSamlConfigsPage from "./edit_saml_config_page";
import { useEditSamlConfig } from "./use_edit_saml_config";

type Params = {
  id: string;
};

const EditSamlConfigController = (): JSX.Element => {
  const { id } = useParams<Params>();
  const { t } = useTranslation(["samlConfigs", "translation"]);
  const { loaded, samlConfig, errors } = useEditSamlConfig(id);
  const WrappedUseSamlConfigPage = usePageWrapper(EditSamlConfigsPage);

  return (
    <WrappedUseSamlConfigPage
      loading={!loaded}
      errors={errors}
      errorComponent={
        <NotFoundComponent
          message={t("samlConfigs:edit.notFoundMessage")}
          buttonMessage={t("translation:comeBackLater")}
          buttonUrl="/admin/saml_configs"
        />
      }
      samlConfig={samlConfig}
      id={id}
    />
  );
};

export default EditSamlConfigController;
